module.exports = __webpack_public_path__ + "img/Device-Test.b986dad9.png";